import {useEffect, useState} from "react";
import {useVendorProductOverview} from "../../../hook/partner/vendorProductOverview.partner.hook";
import {useVendorsStore} from "../../../store/vendors.store";
import {useAuthStore} from "../../../store/auth.store";
import {NavLink} from "react-router";
import { useTranslation } from "../../../hooks/useTranslation";

function VendorDetailProducts(props) {
    const { t } = useTranslation();
    const vendor = props.vendor;

    const [page, setPage] = useState(0);

    const vendorProductOverviewMutation = useVendorProductOverview();

    const token = useAuthStore((state) => state.token);
    const productOverview = useVendorsStore((state) => state.productOverview);

    useEffect(() => {
        if (token) {
            vendorProductOverviewMutation.mutate(
                {token, id: vendor.vendor_id}
            )
        }
    }, [token, vendor]);


    if (vendorProductOverviewMutation.isLoading) {
        return <p>{t("common.loading")}</p>;
    }

    if (productOverview?.length === 0) {
        return <></>;
    }

    return (
        <>
            {/*
            <h1 className={"mt-16 mb-4"}>Produkty</h1>
*/}
            <div className="row">
                <div className="col-12 col-md-3">
                    <div className="menu menu-rounded menu-column menu-gray-600 menu-state-bg fw-semibold">
                        {productOverview?.length > 0 && (
                            productOverview?.map((productOverviewItem, productOverview_key) => (
                                <div className="menu-item" key={productOverview_key}>
                                    <span onClick={() => setPage(productOverview_key)}
                                          className={"cursor-pointer menu-link " + (productOverview_key === page ? "active" : "")}
                                    >
                                        {productOverviewItem.name}
                                    </span>
                                </div>
                            ))
                        )}
                    </div>
                </div>
                <div className="col-12 col-md-9">
                    {productOverview?.length > 0 && (
                        productOverview?.map((productOverviewItem, productOverview_key) => (
                            productOverview_key === page && (
                                <>
                                    <h2 className="mb-4">{productOverviewItem.name}</h2>
                                    <div dangerouslySetInnerHTML={{__html: productOverviewItem.descripton}}/>
                                </>
                            )
                        ))
                    )}
                </div>
            </div>
        </>
    );
}

export default VendorDetailProducts;
